import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './core/guard/auth.guard';
import { NotFoundComponent } from './shared-components/shared/not-found/not-found.component';

const routes: Routes = [
  // { path: '', redirectTo: '/master', pathMatch: 'full' }, // bypass
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule) },
  {
    path: '', component: HomeComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard] , children: [
      { path: '', loadChildren: () => import('./pages/master/master.module').then(mod => mod.MasterModule) },
    ]
  },
  // { path: '**', redirectTo: '', pathMatch: 'full' }
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404', pathMatch: 'full' },
  //   { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
